import { PLATFORMS } from '..'
import { getSponsorshipInfoLG } from '../../../../shared/helpers'
import ariaAnnouncementManager from '../../../../shared/Platform/WebOS/AriaAnnouncementManager'
import configuration from '../../configuration'
import '../../lib/webOSTVjs-1.2.12/webOSTV'
import { store } from '../../store'
import Platform from '../Platform'

export class WebOSPlatform extends Platform {
  _modelName = 'generic-LG-TV'
  _captionSubscriptionHandle = null

  get deviceType() {
    return 'lgtv'
  }

  get deviceModel() {
    return this._modelName
  }

  get featureTogglePlatform() {
    return 'otter-ga-lg'
  }

  constructor() {
    super()
    this._initialize()
  }

  deeplink(deepLinkHandler) {
    const handleIntent = (event) => {
      const intent = event.detail

      if (!intent) return
      const { type, autoplay, videoId, showId } = intent
      let deeplink

      if (type === 'video') {
        deeplink = configuration.deeplinkPatterns['video'].replace(
          '{{videoId}}',
          videoId
        )

        if (autoplay) {
          deeplink = deeplink.replace('video-details', 'video-playback')
        }
      } else if (type === 'show') {
        deeplink = configuration.deeplinkPatterns['show'].replace(
          '{{seriesId}}',
          showId
        )
      }

      if (deeplink) {
        deepLinkHandler(deeplink)
      }
    }

    // COLD LAUNCH
    if (window.webOS && window.webOS.service && window.webOS.service.request) {
      if (window.PalmSystem && window.PalmSystem.launchParams) {
        const detail = JSON.parse(window.PalmSystem.launchParams)
        handleIntent({ detail })
      }
    }
    // WARM LAUNCH
    document.addEventListener('webOSRelaunch', handleIntent)
  }

  async _initialize() {
    try {
      if (window.webOS) {
        window.webOS.deviceInfo(async (device) => {
          this._modelName = device.modelName
          const ppid = await getSponsorshipInfoLG()
          store.dispatch({
            type: 'UPDATE_DEVICE',
            payload: { ...ppid, deviceModel: this._modelName },
          })
        })
      }
    } catch (error) {
      console.error('Error initializing WebOS platform:', error)
    }

    this.configureTTS()
    this._monitorSystemCaptions()
  }

  configureTTS() {
    try {
      ariaAnnouncementManager.createMockingAriaElement()
      // Subscribe to TTS (audioGuidance) settings changes
      window.webOS.service.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'option',
          keys: ['audioGuidance'],
          subscribe: true,
        },
        onSuccess: function (inResponse) {
          console.log('TTS Settings Result: ' + JSON.stringify(inResponse))
          const enabled = inResponse.settings.audioGuidance === 'on'
          store.dispatch({
            type: 'UPDATE_DEVICE',
            payload: {
              ttsEnabled: enabled,
            },
          })
        },
        onFailure: function (inError) {
          console.error('Failed to get TTS settings value')
          console.error('[' + inError.errorCode + ']: ' + inError.errorText)
          return
        },
      })
    } catch (error) {
      console.error('Error activating TTS on WebOS platform:', error)
    }
  }

  _monitorSystemCaptions() {
    try {
      // Cold start - get initial caption settings
      window.webOS.service.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'caption',
          keys: ['captionEnable'],
        },
        onSuccess: (response) => {
          const enabled = response?.settings?.captionEnable === 'on'
          store.dispatch({
            type: 'SET_CAPTION_STATE',
            payload: { enabled },
          })
        },
        onFailure: (error) => {
          console.error('Failed to get initial caption settings:', error)
        },
      })

      // Hot changes - subscribe to caption settings changes
      this._captionSubscriptionHandle = window.webOS.service.request(
        'luna://com.webos.settingsservice',
        {
          method: 'getSystemSettings',
          parameters: {
            category: 'caption',
            keys: ['captionEnable'],
            subscribe: true,
          },
          onSuccess: (response) => {
            console.log('Caption settings changed:', response)
            const enabled = response?.settings?.captionEnable === 'on'
            store.dispatch({
              type: 'SET_CAPTION_STATE',
              payload: {
                enabled,
              },
            })
          },
          onFailure: (error) => {
            console.error('Failed to monitor caption settings:', error)
          },
        }
      )
    } catch (error) {
      console.error('Error monitoring system captions:', error)
    }
  }

  getPlatformName() {
    return PLATFORMS.LG
  }

  reportAppReady() {
    console.log('TODO implement reportAppReady for when necessary')
  }

  getLiveStreamAnalyticsParams() {
    return {
      video_player: configuration.analytics4.webOS.livestream_video_player,
      video_title: configuration.analytics4.webOS.livestream_video_title,
    }
  }

  getMeasurementId() {
    return configuration.analytics4.webOS.measurementId
  }

  shouldResolveUrsUrlInApp() {
    return true
  }
}
